// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --base-font-size: 14px;
  }
  @media (min-width: 768px) {
    :root {
      --base-font-size: calc(14px + 2 * ((100vw - 768px) / 752)); /* font size for laptops and desktops */
    }
  }
  @media (max-width: 767px) {
    :root {
      --base-font-size: calc(12px + 2 * ((100vw - 320px) / 447)); /* font size for mobile devices */
    }
  }
  

.oim-container {
    height: 92% !important;
    width: 99.8% !important;
    position: fixed !important;
    padding: 0px !important;
    box-shadow: rgb(0 0 0 / 20%) 0px 0px 5px 0px !important;
    background-color:white !important;
    /* font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; */
    font-family: Arial, sans-serif !important;
    font-size: var(--base-font-size) !important;
}

.oim-disclaimer-container {
    /* z-index: 9999; */
    position: absolute;
    /* bottom: 15px; */
    /* left: 5px; */
}
.oim-disclaimer-btn{
    color: white !important;
    text-decoration: none !important;
    text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
    font-size: calc(var(--base-font-size) * 0.9) !important;
}

.oim-disclaimer-details {
    color: white;
}

.oim-disclaimer-summary {
    font-weight: bold;
}

.oim-disclaimer-content {
    position: absolute;
    left: 5px;
    bottom: 25px;
    text-align: justify;
    color: black;
    background-color: #cff4fc;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
}

.oim-logo-dsiclaimer{
    height: calc(var(--base-font-size) * 1.5);
}

.oim-manage-container {
    position:absolute !important;
    /* right: 10px !important;  */
    top: 50% !important;
    transform: translateY(-50%); 
}

.oim-manage-layers {
    position: absolute;
    right: 100%;
    border: 1px solid #ccc;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    font-size: calc(var(--base-font-size) * 0.7);
    overflow-y: auto;
    background-color: #f0f0f0;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    color: #333;
    width: calc(var(--base-font-size) * 21);
    overflow: auto; /* Enable scrollbars if content overflows */
    /* resize: both; */
    /* max-width:19vw; */
    /* min-height: 50%;*/
    /* height: 40vh; */
    /* max-height: 100%; */
    /* min-width: 20%; */
    /* background-color: #ffffff; */
    /* width:fit-content; */
    /* display: none; */
}
.oim-panel-heading {
    margin-top: 15px;
    font-size: calc(var(--base-font-size) * 1.1);
}

.oim-panel-btn-close {
    position: absolute;
    right: 10px;
    font-size: calc(var(--base-font-size) * 0.8) !important;
}

.oim-checkboxes-parent {
    z-index: 999;
    max-height: 40%;
    overflow: auto;
    border-radius: 5px;
    display: flex;
    padding: 5px 20px 5px 10px;
    background-color: rgb(255, 255, 255);
    flex-direction: column;
    flex-wrap: wrap;
    /* font-size: small; */
    color: rgb(112, 108, 108);
    box-sizing: border-box;
    font-weight: bold;
    /* box-shadow: rgb(0 0 0 / 20%) 0px 0px 5px 0px; */
    width: calc(fit-content + 10px);
    min-width: fit-content !important;
    font-size: calc(var(--base-font-size) * 0.8);
    
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); */
    border: 1px solid rgb(204, 204, 204);
}

.oim-checkboxes-parent > button.btn-close{
    background-color: #ededed;
}

.oim-checkboxes-top-right-container {
    position: absolute;
    top: 10px;
    right: 10px;
}

.oim-checkboxes-top-left-container {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    flex-direction: column;
}

.oim-checkbox {
    /*margin-bottom: 5px;*/
    display: table-cell;
    vertical-align: middle;
}

.oim-checkbox-label {
    margin-right: 5px;
}

.oim-checkbox-span {
    margin-left: 5px;
    vertical-align: middle;
    /*margin-right: 5px;*/
    /*vertical-align: middle;*/
}



.oim-coordinates-container {
    position: absolute;
    /* right: 5px; */
    bottom: 35px;
    border-radius: 5px;
    z-index: 11111;
}

.oim-coordinates-text {
    font-weight: bold;
    display: inline-block;
    color: #DC143C;
    text-shadow: -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF;
    font-size: calc(var(--base-font-size) * 0.8);
}



.oim-zooms-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.oim-ol-zoom {
    /* left: 10px !important; 
    top: 50% !important;
    transform: translateY(-50%)!important; */
    font-size: calc(var(--base-font-size) * 0.7) !important;
}

.oim-button-toggle {
    position: absolute;
    top: 5px;
    right: 5px;
}

    .oim-button-toggle:hover {
        background-color: #f2f3f3 !important;
        border-radius: 5px !important;
    }
    .oim-button-size-sm{
        padding: 0.3rem !important;
        font-size: calc(var(--base-font-size) * 0.7) !important;
    }

.oim-icon-active {
    background-color: #ff0 !important;
    border-radius: 8px;
    padding: 8px 16px;
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
    /* color: blue !important;
    background-color: #007bff;
    border-radius: 50%;
    padding: 5px;
    border: 4px solid #fff;
    border: 2px solid #ff0 !important; */
}



.oim-my-handle {
    cursor: -webkit-grabbing;
}

.oim-list-layers {
    list-style: none;
}

.oim-list-layers > li {
    word-break: break-all;
}

.oim-btn-add-layer:hover{
    background-color: lightgrey !important
    
    ;
}

.oim-btn-add-flag{
    color: green;
    font-weight: bold;
}

.ol-tooltip-measure {
    opacity: 1;
    font-weight: bold;
}
.ol-tooltip {
    position: relative;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    color: white;
    padding: 4px 8px;
    opacity: 0.7;
    white-space: nowrap;
    font-size: 0.7rem;
}

.oim-tooltip{
    /* background-color: #4b4d4f !important;
    color: white !important; */
    text-align: justify !important;
    font-size:  calc(var(--base-font-size) * 0.7) !important;
    font-style: italic;
    /* background-image: url('../assets/itu_logo.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-color: rgba(255, 255, 255, 0.1) */
}
.oim-tooltip-content{
    color: white !important;

}

.oim-separator-h {
    /* background-color: #ccc; */
    margin: 7px 0;
    align-self: normal;
    height: 1px;
    opacity: 1;
    background-color: white;
  }
  .oim-w98{
    width:98% !important;
  }
  .oim-w-fit-content{
    width:fit-content!important;
  }
  .oim-fade-in {
    opacity: 0;
    height: 0;
    transition: opacity 0.5s ease-in-out, height 0.5s ease-in-out;
  }
  .oim-fade-in.show {
    opacity: 1;
    height: 40vh;
  }
  .oim-table-markers{
    max-height: 200px; /* Set the maximum height */
    overflow: auto; /* Enable vertical scrolling */
  }
  .oim-tooltip-format{
    font-size: 11px !important;
  }

  .oim-map-infos-container {
    font-weight: bold;
    color: white;
    background-color: gray;
    border-radius: 5px;
    z-index: 11111;
    position: absolute;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
}
.oim-map-infos-container-padding {
    padding: 5px;
}

.oim-loader-wrapper {
    text-align: center; 
    position: absolute;
    width: 128px;
    height: 128px;
    top: 50%;
    right: 50%;
    z-index: 99999;
  }
  .oim-spinner{
    text-align: center; 
    width: 128px;
    height: 128px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

  .oim-list-grab{
    list-style: none;
    cursor: -webkit-grabbing;
    font-size: 0.7rem;
    padding: .5rem 1rem;
    color: #212529;
    background-color: #fff;
    border: 1px solid #ccc;
    transition: transform 0.5s ease-in-out;
  }
  
  .oim-list-grab-move{
    /* border: 2px solid rgb(0, 0, 0); */
    /* transform: translateX(1%); */
    font-weight: bolder;
    border: 2px solid #ccc;;
    margin-top:5px;
  }

  .oim-ol-tooltip {
    opacity: 1;
    font-weight: bold;
    display: none;
}

    .oim-ol-tooltip:before {
        border-top: 6px solid rgba(0, 0, 0, 0.5);
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        content: "";
        position: absolute;
        bottom: -6px;
        margin-left: -7px;
        left: 50%;
    }

    .oim-add-layers-group-header{
        list-style: none;
        font-weight: bold;
    }

    .oim-legend{
        max-height: calc(var(--base-font-size) * 15);
        max-width: fit-content;
    }
    .oim-popup-left {
        position: absolute;
        background-color: white;
        box-shadow: 0 1px 4px rgba(0,0,0,0.2);
        padding: 15px;
        border-radius: 10px;
        border: 1px solid #cccccc;
        bottom: 12px;
        left: -50px;
        min-width: 350px;
        z-index: 11112;
        display: none;
    }
    .oim-popup-left:after, 
    .oim-popup-left:before {
        top: 100%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }
    .oim-popup-left:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
}

.oim-popup-left-decoration {
    height: 30px;
    background-color: ghostwhite; /*aliceblue; ghostwhite; lavender; oldlace*/
    margin: -15px;
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.oim-popup-left-title {
    font-weight: bold;
    position: absolute;
    top: 5px;
    left: 5px;
}

.oim-popup-closer {
    text-decoration: none !important;
    position: absolute;
    top: 5px;
    right: 20px;
    color: #0044cc;
    font-size: x-small;
}

    .oim-popup-closer:hover {
        color: red;
        font-size: small;
        font-weight: bold;
    }

.oim-popup-closer:after {
    content: "✖";
}
.oim-popup-left-content{
    overflow: auto;
    max-height: 150px;
    position: relative;
    margin-top: 20px;
}

.oim-popup-left-content span {
    color:#004B96 !important;
    font-size: 10px;
    text-decoration: none !important;
    font-family: Verdana, Geneva, Arial, Helvetica, sans-serif;
    font-weight: bold;
    cursor: pointer;
}

    .oim-popup-left-content span:hover {
        font-size: 11px;
        color: #9600ff !important;
    }
    .oim-ol-overviewmap,
      .oim-ol-overviewmap.ol-uncollapsible {
        bottom: auto;
        left: auto;
        right: 0;
        top: 0;
        opacity: 1;
      }

      .oim-ol-overviewmap:not(.ol-collapsed)  {
        border: 1px solid black;
      }

      .oim-ol-overviewmap .ol-overviewmap-map {
        border: none;
        width: 300px;
      }

      .oim-ol-overviewmap .ol-overviewmap-box {
        border: 2px solid red;
      }

      .oim-ol-overviewmap:not(.ol-collapsed) button{
        bottom: auto;
        left: auto;
        right: 1px;
        top: 1px;
      }`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;EACxB;EACA;IACE;MACE,0DAA0D,EAAE,uCAAuC;IACrG;EACF;EACA;IACE;MACE,0DAA0D,EAAE,iCAAiC;IAC/F;EACF;;;AAGF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uDAAuD;IACvD,iCAAiC;IACjC,gEAAgE;IAChE,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,mFAAmF;IACnF,uDAAuD;AAC3D;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,0CAA0C;IAC1C,4CAA4C;IAC5C,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;IACX,uCAAuC;IACvC,cAAc,EAAE,2CAA2C;IAC3D,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,+BAA+B;IAC/B,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uDAAuD;AAC3D;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,kDAAkD;IAClD,+BAA+B;IAC/B,iCAAiC;IACjC,4CAA4C;;IAE5C,gDAAgD;IAChD,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;AAC9B;;;;AAIA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,+EAA+E;IAC/E,4CAA4C;AAChD;;;;AAIA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI;;4CAEwC;IACxC,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;IAEI;QACI,oCAAoC;QACpC,6BAA6B;IACjC;IACA;QACI,0BAA0B;QAC1B,uDAAuD;IAC3D;;AAEJ;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,+EAA+E;IAC/E;;;;;wCAKoC;AACxC;;;;AAIA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;;IAEA;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;8BAC0B;IAC1B,8BAA8B;IAC9B,wDAAwD;IACxD,kBAAkB;IAClB;;;gDAG4C;AAChD;AACA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,SAAS;IACT,6DAA6D;EAC/D;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,iBAAiB,EAAE,2BAA2B;IAC9C,cAAc,EAAE,8BAA8B;EAChD;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,UAAU;IACV,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;EAEE;IACE,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;IACpC,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;AACjB;;IAEI;QACI,wCAAwC;QACxC,mCAAmC;QACnC,kCAAkC;QAClC,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,4CAA4C;QAC5C,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,qCAAqC;QACrC,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,aAAa;IACjB;IACA;;QAEI,SAAS;QACT,yBAAyB;QACzB,YAAY;QACZ,SAAS;QACT,QAAQ;QACR,kBAAkB;QAClB,oBAAoB;IACxB;IACA;IACA,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,4BAA4B,EAAE,2CAA2C;IACzE,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;IAEI;QACI,UAAU;QACV,gBAAgB;QAChB,iBAAiB;IACrB;;AAEJ;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gCAAgC;IAChC,0DAA0D;IAC1D,iBAAiB;IACjB,eAAe;AACnB;;IAEI;QACI,eAAe;QACf,yBAAyB;IAC7B;IACA;;QAEI,YAAY;QACZ,UAAU;QACV,QAAQ;QACR,MAAM;QACN,UAAU;MACZ;;MAEA;QACE,uBAAuB;MACzB;;MAEA;QACE,YAAY;QACZ,YAAY;MACd;;MAEA;QACE,qBAAqB;MACvB;;MAEA;QACE,YAAY;QACZ,UAAU;QACV,UAAU;QACV,QAAQ;MACV","sourcesContent":[":root {\r\n    --base-font-size: 14px;\r\n  }\r\n  @media (min-width: 768px) {\r\n    :root {\r\n      --base-font-size: calc(14px + 2 * ((100vw - 768px) / 752)); /* font size for laptops and desktops */\r\n    }\r\n  }\r\n  @media (max-width: 767px) {\r\n    :root {\r\n      --base-font-size: calc(12px + 2 * ((100vw - 320px) / 447)); /* font size for mobile devices */\r\n    }\r\n  }\r\n  \r\n\r\n.oim-container {\r\n    height: 92% !important;\r\n    width: 99.8% !important;\r\n    position: fixed !important;\r\n    padding: 0px !important;\r\n    box-shadow: rgb(0 0 0 / 20%) 0px 0px 5px 0px !important;\r\n    background-color:white !important;\r\n    /* font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; */\r\n    font-family: Arial, sans-serif !important;\r\n    font-size: var(--base-font-size) !important;\r\n}\r\n\r\n.oim-disclaimer-container {\r\n    /* z-index: 9999; */\r\n    position: absolute;\r\n    /* bottom: 15px; */\r\n    /* left: 5px; */\r\n}\r\n.oim-disclaimer-btn{\r\n    color: white !important;\r\n    text-decoration: none !important;\r\n    text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;\r\n    font-size: calc(var(--base-font-size) * 0.9) !important;\r\n}\r\n\r\n.oim-disclaimer-details {\r\n    color: white;\r\n}\r\n\r\n.oim-disclaimer-summary {\r\n    font-weight: bold;\r\n}\r\n\r\n.oim-disclaimer-content {\r\n    position: absolute;\r\n    left: 5px;\r\n    bottom: 25px;\r\n    text-align: justify;\r\n    color: black;\r\n    background-color: #cff4fc;\r\n    border: 1px solid #ccc;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,.1);\r\n}\r\n\r\n.oim-logo-dsiclaimer{\r\n    height: calc(var(--base-font-size) * 1.5);\r\n}\r\n\r\n.oim-manage-container {\r\n    position:absolute !important;\r\n    /* right: 10px !important;  */\r\n    top: 50% !important;\r\n    transform: translateY(-50%); \r\n}\r\n\r\n.oim-manage-layers {\r\n    position: absolute;\r\n    right: 100%;\r\n    border: 1px solid #ccc;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n    font-size: calc(var(--base-font-size) * 0.7);\r\n    overflow-y: auto;\r\n    background-color: #f0f0f0;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    color: #333;\r\n    width: calc(var(--base-font-size) * 21);\r\n    overflow: auto; /* Enable scrollbars if content overflows */\r\n    /* resize: both; */\r\n    /* max-width:19vw; */\r\n    /* min-height: 50%;*/\r\n    /* height: 40vh; */\r\n    /* max-height: 100%; */\r\n    /* min-width: 20%; */\r\n    /* background-color: #ffffff; */\r\n    /* width:fit-content; */\r\n    /* display: none; */\r\n}\r\n.oim-panel-heading {\r\n    margin-top: 15px;\r\n    font-size: calc(var(--base-font-size) * 1.1);\r\n}\r\n\r\n.oim-panel-btn-close {\r\n    position: absolute;\r\n    right: 10px;\r\n    font-size: calc(var(--base-font-size) * 0.8) !important;\r\n}\r\n\r\n.oim-checkboxes-parent {\r\n    z-index: 999;\r\n    max-height: 40%;\r\n    overflow: auto;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    padding: 5px 20px 5px 10px;\r\n    background-color: rgb(255, 255, 255);\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    /* font-size: small; */\r\n    color: rgb(112, 108, 108);\r\n    box-sizing: border-box;\r\n    font-weight: bold;\r\n    /* box-shadow: rgb(0 0 0 / 20%) 0px 0px 5px 0px; */\r\n    width: calc(fit-content + 10px);\r\n    min-width: fit-content !important;\r\n    font-size: calc(var(--base-font-size) * 0.8);\r\n    \r\n    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); */\r\n    border: 1px solid rgb(204, 204, 204);\r\n}\r\n\r\n.oim-checkboxes-parent > button.btn-close{\r\n    background-color: #ededed;\r\n}\r\n\r\n.oim-checkboxes-top-right-container {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n}\r\n\r\n.oim-checkboxes-top-left-container {\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.oim-checkbox {\r\n    /*margin-bottom: 5px;*/\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}\r\n\r\n.oim-checkbox-label {\r\n    margin-right: 5px;\r\n}\r\n\r\n.oim-checkbox-span {\r\n    margin-left: 5px;\r\n    vertical-align: middle;\r\n    /*margin-right: 5px;*/\r\n    /*vertical-align: middle;*/\r\n}\r\n\r\n\r\n\r\n.oim-coordinates-container {\r\n    position: absolute;\r\n    /* right: 5px; */\r\n    bottom: 35px;\r\n    border-radius: 5px;\r\n    z-index: 11111;\r\n}\r\n\r\n.oim-coordinates-text {\r\n    font-weight: bold;\r\n    display: inline-block;\r\n    color: #DC143C;\r\n    text-shadow: -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF;\r\n    font-size: calc(var(--base-font-size) * 0.8);\r\n}\r\n\r\n\r\n\r\n.oim-zooms-container {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.oim-ol-zoom {\r\n    /* left: 10px !important; \r\n    top: 50% !important;\r\n    transform: translateY(-50%)!important; */\r\n    font-size: calc(var(--base-font-size) * 0.7) !important;\r\n}\r\n\r\n.oim-button-toggle {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 5px;\r\n}\r\n\r\n    .oim-button-toggle:hover {\r\n        background-color: #f2f3f3 !important;\r\n        border-radius: 5px !important;\r\n    }\r\n    .oim-button-size-sm{\r\n        padding: 0.3rem !important;\r\n        font-size: calc(var(--base-font-size) * 0.7) !important;\r\n    }\r\n\r\n.oim-icon-active {\r\n    background-color: #ff0 !important;\r\n    border-radius: 8px;\r\n    padding: 8px 16px;\r\n    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\r\n    /* color: blue !important;\r\n    background-color: #007bff;\r\n    border-radius: 50%;\r\n    padding: 5px;\r\n    border: 4px solid #fff;\r\n    border: 2px solid #ff0 !important; */\r\n}\r\n\r\n\r\n\r\n.oim-my-handle {\r\n    cursor: -webkit-grabbing;\r\n}\r\n\r\n.oim-list-layers {\r\n    list-style: none;\r\n}\r\n\r\n.oim-list-layers > li {\r\n    word-break: break-all;\r\n}\r\n\r\n.oim-btn-add-layer:hover{\r\n    background-color: lightgrey !important\r\n    \r\n    ;\r\n}\r\n\r\n.oim-btn-add-flag{\r\n    color: green;\r\n    font-weight: bold;\r\n}\r\n\r\n.ol-tooltip-measure {\r\n    opacity: 1;\r\n    font-weight: bold;\r\n}\r\n.ol-tooltip {\r\n    position: relative;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    border-radius: 4px;\r\n    color: white;\r\n    padding: 4px 8px;\r\n    opacity: 0.7;\r\n    white-space: nowrap;\r\n    font-size: 0.7rem;\r\n}\r\n\r\n.oim-tooltip{\r\n    /* background-color: #4b4d4f !important;\r\n    color: white !important; */\r\n    text-align: justify !important;\r\n    font-size:  calc(var(--base-font-size) * 0.7) !important;\r\n    font-style: italic;\r\n    /* background-image: url('../assets/itu_logo.svg');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-color: rgba(255, 255, 255, 0.1) */\r\n}\r\n.oim-tooltip-content{\r\n    color: white !important;\r\n\r\n}\r\n\r\n.oim-separator-h {\r\n    /* background-color: #ccc; */\r\n    margin: 7px 0;\r\n    align-self: normal;\r\n    height: 1px;\r\n    opacity: 1;\r\n    background-color: white;\r\n  }\r\n  .oim-w98{\r\n    width:98% !important;\r\n  }\r\n  .oim-w-fit-content{\r\n    width:fit-content!important;\r\n  }\r\n  .oim-fade-in {\r\n    opacity: 0;\r\n    height: 0;\r\n    transition: opacity 0.5s ease-in-out, height 0.5s ease-in-out;\r\n  }\r\n  .oim-fade-in.show {\r\n    opacity: 1;\r\n    height: 40vh;\r\n  }\r\n  .oim-table-markers{\r\n    max-height: 200px; /* Set the maximum height */\r\n    overflow: auto; /* Enable vertical scrolling */\r\n  }\r\n  .oim-tooltip-format{\r\n    font-size: 11px !important;\r\n  }\r\n\r\n  .oim-map-infos-container {\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: gray;\r\n    border-radius: 5px;\r\n    z-index: 11111;\r\n    position: absolute;\r\n    bottom: 25px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n.oim-map-infos-container-padding {\r\n    padding: 5px;\r\n}\r\n\r\n.oim-loader-wrapper {\r\n    text-align: center; \r\n    position: absolute;\r\n    width: 128px;\r\n    height: 128px;\r\n    top: 50%;\r\n    right: 50%;\r\n    z-index: 99999;\r\n  }\r\n  .oim-spinner{\r\n    text-align: center; \r\n    width: 128px;\r\n    height: 128px;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n  .oim-list-grab{\r\n    list-style: none;\r\n    cursor: -webkit-grabbing;\r\n    font-size: 0.7rem;\r\n    padding: .5rem 1rem;\r\n    color: #212529;\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    transition: transform 0.5s ease-in-out;\r\n  }\r\n  \r\n  .oim-list-grab-move{\r\n    /* border: 2px solid rgb(0, 0, 0); */\r\n    /* transform: translateX(1%); */\r\n    font-weight: bolder;\r\n    border: 2px solid #ccc;;\r\n    margin-top:5px;\r\n  }\r\n\r\n  .oim-ol-tooltip {\r\n    opacity: 1;\r\n    font-weight: bold;\r\n    display: none;\r\n}\r\n\r\n    .oim-ol-tooltip:before {\r\n        border-top: 6px solid rgba(0, 0, 0, 0.5);\r\n        border-right: 6px solid transparent;\r\n        border-left: 6px solid transparent;\r\n        content: \"\";\r\n        position: absolute;\r\n        bottom: -6px;\r\n        margin-left: -7px;\r\n        left: 50%;\r\n    }\r\n\r\n    .oim-add-layers-group-header{\r\n        list-style: none;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .oim-legend{\r\n        max-height: calc(var(--base-font-size) * 15);\r\n        max-width: fit-content;\r\n    }\r\n    .oim-popup-left {\r\n        position: absolute;\r\n        background-color: white;\r\n        box-shadow: 0 1px 4px rgba(0,0,0,0.2);\r\n        padding: 15px;\r\n        border-radius: 10px;\r\n        border: 1px solid #cccccc;\r\n        bottom: 12px;\r\n        left: -50px;\r\n        min-width: 350px;\r\n        z-index: 11112;\r\n        display: none;\r\n    }\r\n    .oim-popup-left:after, \r\n    .oim-popup-left:before {\r\n        top: 100%;\r\n        border: solid transparent;\r\n        content: \" \";\r\n        height: 0;\r\n        width: 0;\r\n        position: absolute;\r\n        pointer-events: none;\r\n    }\r\n    .oim-popup-left:after {\r\n    border-top-color: white;\r\n    border-width: 10px;\r\n    left: 48px;\r\n    margin-left: -10px;\r\n}\r\n\r\n.oim-popup-left-decoration {\r\n    height: 30px;\r\n    background-color: ghostwhite; /*aliceblue; ghostwhite; lavender; oldlace*/\r\n    margin: -15px;\r\n    position: relative;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n}\r\n.oim-popup-left-title {\r\n    font-weight: bold;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 5px;\r\n}\r\n\r\n.oim-popup-closer {\r\n    text-decoration: none !important;\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 20px;\r\n    color: #0044cc;\r\n    font-size: x-small;\r\n}\r\n\r\n    .oim-popup-closer:hover {\r\n        color: red;\r\n        font-size: small;\r\n        font-weight: bold;\r\n    }\r\n\r\n.oim-popup-closer:after {\r\n    content: \"✖\";\r\n}\r\n.oim-popup-left-content{\r\n    overflow: auto;\r\n    max-height: 150px;\r\n    position: relative;\r\n    margin-top: 20px;\r\n}\r\n\r\n.oim-popup-left-content span {\r\n    color:#004B96 !important;\r\n    font-size: 10px;\r\n    text-decoration: none !important;\r\n    font-family: Verdana, Geneva, Arial, Helvetica, sans-serif;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n\r\n    .oim-popup-left-content span:hover {\r\n        font-size: 11px;\r\n        color: #9600ff !important;\r\n    }\r\n    .oim-ol-overviewmap,\r\n      .oim-ol-overviewmap.ol-uncollapsible {\r\n        bottom: auto;\r\n        left: auto;\r\n        right: 0;\r\n        top: 0;\r\n        opacity: 1;\r\n      }\r\n\r\n      .oim-ol-overviewmap:not(.ol-collapsed)  {\r\n        border: 1px solid black;\r\n      }\r\n\r\n      .oim-ol-overviewmap .ol-overviewmap-map {\r\n        border: none;\r\n        width: 300px;\r\n      }\r\n\r\n      .oim-ol-overviewmap .ol-overviewmap-box {\r\n        border: 2px solid red;\r\n      }\r\n\r\n      .oim-ol-overviewmap:not(.ol-collapsed) button{\r\n        bottom: auto;\r\n        left: auto;\r\n        right: 1px;\r\n        top: 1px;\r\n      }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
